import {
  FormFieldBlueprint,
  createFormField,
} from '@backstage/plugin-scaffolder-react/alpha';
import {
  DependentEnvBranchInput,
  dependentEnvBranchInputSchema,
  dependentEnvBranchInputValidation,
} from './DependentEnvBranchInput';

export const DependentEnvBranchInputExtension = FormFieldBlueprint.make({
  name: 'DependentEnvBranchInput',
  params: {
    field: async () =>
      createFormField({
        name: 'DependentEnvBranchInput',
        component: DependentEnvBranchInput,
        schema: dependentEnvBranchInputSchema,
        validation: dependentEnvBranchInputValidation,
      }),
  },
});
